<template>
  <div>TODO: Implement Global Product Page</div>
</template>

<script setup lang="ts"></script>
